<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 fs_14ForMobile font_regular">Add Letter</p>
        </div>
        <div class="popup-close">
          <span class="ml-35 mr-5 fs-30 material-icons popup-close-icon" (click)="onClickClosePopup()">close</span>
        </div>
      </div>

    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="6" size-md="7" size-lg="7" size-xs="6">
      <ion-row class="display-space-between">
        <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
          <p class="fs-16 fs_14ForMobile font_semibold">Letter Name:</p>
        </ion-col>
        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40  mat-input-style">
            <input matInput [(ngModel)]="addlLetterName" placeholder="Type here"
              (ngModelChange)="isValicIncrementLetter()"   maxlength="255">
          </mat-form-field>
          <div *ngIf="isInValidlLetterName" class="fs-14 fs_12ForMobile red mt-5">Enter Letter Name</div>
          <div *ngIf="errorMessage" class="fs-14 fs_12ForMobile red mt-5">
            This letter name already exists. Please enter a different letter name.
          </div>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size-sm="6" size-md="5" size-lg="5" size-xs="6">
      <div class="btn-Group">
        <button class="saveBtn" (click)="onClickSaveBtn()"
          [ngClass]="{ 'disable': isDisabledIncrementLetter }">Save</button>
        <button class="mr-20 DiscardChangesBtn"  (click)="onClickDiscardChanges()" >Cancel</button>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="6" size-md="7" size-lg="7" size-xs="6">
      <ion-row class="display-space-between">
        <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
          <p class="fs-16 fs_14ForMobile font_semibold">Subject:</p>
        </ion-col>
        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class=" w-100 mat-height40  mat-input-style">
            <input matInput [(ngModel)]="addEmailSubject" placeholder="Type here"
              (ngModelChange)="isValicIncrementLetter()" maxlength="255">
          </mat-form-field>
          <div *ngIf="isInValidLetterSubject" class="fs-14 fs_12ForMobile red mt-5">Enter Letter Subject</div>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <!-- <ion-row>
  <ion-col>
    <angular-editor [placeholder]="'Enter Email here...'" [config]="editorConfig"
    [(ngModel)]="AddLetterContent" (ngModelChange)="isValicIncrementLetter()" (click)="onClickRemoveLetterSubject()"></angular-editor>
    <div *ngIf="isInvalidLetterBody" class="fs-14 fs_12ForMobile red mt-5">Enter Letter Email</div>
  </ion-col>
</ion-row> -->
  <div>
    <ion-row>
      <ion-col size="12" class="mb-10">
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Salutation#')"
          [ngClass]="'green-bg'">#Salutation#</button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeName#')"
          [ngClass]="'green-bg'">#EmployeeName#</button>

        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DesignationOld#')"
          [ngClass]="'green-bg'">#DesignationOld#</button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#DesignationNew#')"
          [ngClass]="'green-bg'">#DesignationNew#</button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#IncrementPercentage#')" [ngClass]="'green-bg'">
          #IncrementPercentage#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#IncrementAmount#')" [ngClass]="'green-bg'">
          #IncrementAmount#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#OldCtcPa#')" [ngClass]="'green-bg'">
          #OldCtcPa#
        </button>
          <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#OldCtcPm#')" [ngClass]="'green-bg'">
          #OldCtcPm#
        </button>
          <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Rating#')" [ngClass]="'green-bg'">
          #Rating#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Score#')" [ngClass]="'green-bg'">
          #Score#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#RevisedCtcPa#')" [ngClass]="'green-bg'">
          #RevisedCtcPa#
        </button>
         <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#RevisedCtcPm#')" [ngClass]="'green-bg'">
          #RevisedCtcPm#
        </button>
       
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationCity#')" [ngClass]="'green-bg'">
          #WorkLocationCity#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#WorkLocationState#')" [ngClass]="'green-bg'">
          #WorkLocationState#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#ManagerName#')" [ngClass]="'green-bg'">
          #ManagerName#
        </button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#EmployeeCode#')"
          [ngClass]="'green-bg'">#EmployeeCode#</button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Grade#')" [ngClass]="'green-bg'">#Grade#</button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Band#')" [ngClass]="'green-bg'">#Band#</button>
        
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#Department#')"
          [ngClass]="'green-bg'">#Department#</button>
        <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#TodayDate#')" [ngClass]="'green-bg'">#TodayDate#</button>
         
       <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#CompanyName#')"
          [ngClass]="'green-bg'">#CompanyName#</button>
         <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#SignaturePath#')"
          [ngClass]="'green-bg'">#SignaturePath#</button>
         <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#HrEmail#')"
                  [ngClass]="'green-bg'">#HrEmail#</button>
                <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#LetterType#')"
                  [ngClass]="'green-bg'">#LetterType#</button>
                    <button class="back_btn fs-14 fs_12ForMobile" (click)="addToEditor('#PromotionContent#')"
                  [ngClass]="'green-bg'">#PromotionContent#</button>
      </ion-col>
    </ion-row>



<jodit-editor 
  *ngIf="editorConfig"
  id="htmlDiv"
  [config]="editorConfig"
  [(ngModel)]="AddLetterContent"
 >
</jodit-editor>

  </div>
</div>